import { merge } from './helpers.mjs';
import { setVueInstance, setOptions, Programmatic, getOptions } from './config.mjs';
export { Plugin as Config, Programmatic as ConfigProgrammatic } from './config.mjs';
import { r as registerPlugin, a as registerComponentProgrammatic, u as use } from './plugins-a4da84c4.mjs';
import './Icon-76d58102.mjs';
import './FormElementMixin-8424e4ab.mjs';
import './Input-84d6cd7d.mjs';
import './Autocomplete-8297bb72.mjs';
import Plugin from './autocomplete.mjs';
export { default as Autocomplete } from './autocomplete.mjs';
import './Button-79b47ce9.mjs';
import Plugin$1 from './button.mjs';
export { default as Button } from './button.mjs';
import './InjectedChildMixin-bd39b65e.mjs';
import Plugin$2 from './carousel.mjs';
export { default as Carousel } from './carousel.mjs';
import './CheckRadioMixin-5804b41c.mjs';
import './Checkbox-8ddca775.mjs';
import Plugin$3 from './checkbox.mjs';
export { default as Checkbox } from './checkbox.mjs';
import Plugin$4 from './collapse.mjs';
export { default as Collapse } from './collapse.mjs';
import './MatchMediaMixin-2d99700d.mjs';
import './trapFocus-21978f6e.mjs';
import './DropdownItem-79154d71.mjs';
import './Select-691e3e38.mjs';
import './Datepicker-76e80fdb.mjs';
import Plugin$5 from './datepicker.mjs';
export { default as Datepicker } from './datepicker.mjs';
import './Timepicker-f25a92fc.mjs';
import Plugin$6 from './datetimepicker.mjs';
export { default as Datetimepicker } from './datetimepicker.mjs';
import Plugin$7 from './dropdown.mjs';
export { default as Dropdown } from './dropdown.mjs';
import './Field-945a4e2f.mjs';
import Plugin$8 from './field.mjs';
export { default as Field } from './field.mjs';
import Plugin$9 from './icon.mjs';
export { default as Icon } from './icon.mjs';
import Plugin$a from './input.mjs';
export { default as Input } from './input.mjs';
import Plugin$b from './inputitems.mjs';
export { default as Inputitems } from './inputitems.mjs';
import './ssr-acde8f04.mjs';
import './Loading-c64f5492.mjs';
import Plugin$c from './loading.mjs';
export { default as Loading, LoadingProgrammatic } from './loading.mjs';
import Plugin$e from './notification.mjs';
export { default as Notification, default as NotificationNotice, NotificationProgrammatic } from './notification.mjs';
import Plugin$d from './modal.mjs';
export { default as Modal, ModalProgrammatic } from './modal.mjs';
import './Pagination-491183e7.mjs';
import Plugin$f from './pagination.mjs';
export { default as Pagination } from './pagination.mjs';
import Plugin$g from './radio.mjs';
export { default as Radio } from './radio.mjs';
import Plugin$h from './select.mjs';
export { default as Select } from './select.mjs';
import Plugin$i from './skeleton.mjs';
export { default as Skeleton } from './skeleton.mjs';
import Plugin$j from './sidebar.mjs';
export { default as Sidebar } from './sidebar.mjs';
import './Tooltip-2dfb83d7.mjs';
import Plugin$k from './slider.mjs';
export { default as Slider } from './slider.mjs';
import './SlotComponent-1b1e66c6.mjs';
import './TabbedChildMixin-9ab3cb5e.mjs';
import Plugin$l from './steps.mjs';
export { default as Steps } from './steps.mjs';
import Plugin$m from './switch.mjs';
export { default as Switch } from './switch.mjs';
import Plugin$n from './table.mjs';
export { default as Table } from './table.mjs';
import Plugin$o from './tabs.mjs';
export { default as Tabs } from './tabs.mjs';
import Plugin$p from './timepicker.mjs';
export { default as Timepicker } from './timepicker.mjs';
import Plugin$q from './tooltip.mjs';
export { default as Tooltip } from './tooltip.mjs';
import Plugin$r from './upload.mjs';
export { default as Upload } from './upload.mjs';

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Autocomplete: Plugin,
    Button: Plugin$1,
    Carousel: Plugin$2,
    Checkbox: Plugin$3,
    Collapse: Plugin$4,
    Datepicker: Plugin$5,
    Datetimepicker: Plugin$6,
    Dropdown: Plugin$7,
    Field: Plugin$8,
    Icon: Plugin$9,
    Input: Plugin$a,
    Inputitems: Plugin$b,
    Loading: Plugin$c,
    Modal: Plugin$d,
    Notification: Plugin$e,
    NotificationNotice: Plugin$e,
    Pagination: Plugin$f,
    Radio: Plugin$g,
    Select: Plugin$h,
    Skeleton: Plugin$i,
    Sidebar: Plugin$j,
    Slider: Plugin$k,
    Steps: Plugin$l,
    Switch: Plugin$m,
    Table: Plugin$n,
    Tabs: Plugin$o,
    Timepicker: Plugin$p,
    Tooltip: Plugin$q,
    Upload: Plugin$r
});

const Oruga = {
  install(Vue, options = {}) {
    setVueInstance(Vue); // Options

    const defaultConfig = getOptions();
    setOptions(merge(defaultConfig, options, true)); // Components

    for (const componentKey in components) {
      registerPlugin(Vue, components[componentKey]);
    } // Config component


    registerComponentProgrammatic(Vue, 'config', Programmatic);
  }

};
use(Oruga);

export default Oruga;
